import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16C0 7.1875 7.125 0 16 0ZM22 20.5V11.5C22 10.6875 21.3125 10 20.5 10H11.5C10.625 10 10 10.6875 10 11.5V20.5C10 21.375 10.625 22 11.5 22H20.5C21.3125 22 22 21.375 22 20.5Z'],
  name: 'uiCircleStopSolid'
} as IconDefinition
